module.exports = __webpack_public_path__ + "img/68eb86eb1d0ca0689b78f86c93a45210.png";